import * as types from '../../constants/UserActionTypes';
import { createAction } from 'redux-actions';

export const userChangeRole = createAction(types.USER_CHANGE_ROLE);
export const userLogout = createAction(types.USER_LOGOUT);
